import type { Campaign } from '@cvo/domain';

export default defineNuxtPlugin({
  name: 'campaign-fetch',
  dependsOn: ['keycloak', 'user-fetch'],
  async setup() {
    const userStore = useUserStore();

    if (userStore.isActiveUser) return;

    const api = useApi();
    const campaigns = useState<Campaign[]>('campaigns', () => []);

    try {
      const { data } = await api.campaigns.list();
      campaigns.value = data ?? [];
    } catch (error) {
      console.error('[campaign-fetch] Failed to fetch campaigns', error);
      useO11y().reportError(error, { tags: { action: 'fetch-campaigns' } });
    }
  },
});
